const colors = {
  primary: '#004E9E',
  highlight: '#3299FF',
  success: '#00BC8C',
  warning: '#F39C11',
  error: '#E84C3D',
  info: '#3598DB',
  grey: '#C6C6C6',
  accent: '#EA4F53',
  darktrans: 'rgba(0, 0, 0, 0.2)',
  background: '#C1E3FF',
  active: '#3B3B3B',
}

export {
  colors
}
